import { withInstall } from "../../utils/vue/install.mjs";
import { tagEmits, tagProps } from "./src/tag.mjs";
import tag_default from "./src/tag2.mjs";

//#region ../../packages/components/tag/index.ts
const ElTag = withInstall(tag_default);

//#endregion
export { ElTag, ElTag as default, tagEmits, tagProps };
//# sourceMappingURL=index.mjs.map